import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import uploadImage from '../helpers/uploadImage';
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const AdminEditCategory = ({ onClose, categoryData, fetchData }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    id : categoryData?._id || "",
    categoryName: categoryData?.categoryName || "",
    image: categoryData?.image || "",
    subCategories: categoryData?.subCategories || [],
  }); 

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUploadImage = async (e) => {
    const file = e.target.files[0];
    const uploadedImage = await uploadImage(file);
    setData((prev) => ({ ...prev, image: uploadedImage.url }));
  };

  const handleDeleteImage = () => {
    setData((prev) => ({ ...prev, image: "" }));
  };

  const handleAddSubCategory = () => {
    setData((prev) => ({ ...prev, subCategories: [...prev.subCategories, ""] }));
  };

  const handleRemoveSubCategory = (index) => {
    setData((prev) => ({
      ...prev,
      subCategories: prev.subCategories.filter((_, i) => i !== index)
    }));
  };

  const handleSubCategoryChange = (index, value) => {
    setData((prev) => ({
      ...prev,
      subCategories: prev.subCategories.map((sub, i) => (i === index ? value : sub)),
    }));
    
  };



  

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(SummaryApi.updateCategory.url, {
      method: SummaryApi.updateCategory.method,
        headers: { 
    "content-type": "application/json",
  },
      credentials: 'include',
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    });
    const responseData = await response.json();
    responseData.success ? toast.success(responseData.message) : toast.success('Update Successful');
    navigate(0);
    if (responseData.success) {
      onClose();
      
      fetchData();
    }
  };

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 right-0 flex justify-center items-center'>
      <div className='bg-white p-4 rounded w-full max-w-2xl h-full max-h-[80%] overflow-hidden'>
        <div className='flex justify-between items-center pb-3'>
          <h2 className='font-bold text-lg'>Edit Category</h2>
          <div className='w-fit ml-auto text-2xl hover:text-red-600 cursor-pointer' onClick={onClose}>
            <CgClose />
          </div>
        </div>

        <form className='grid p-4 gap-2 overflow-y-scroll h-full pb-5' onSubmit={handleSubmit}>
          <label htmlFor='categoryName'>Category Name:</label>
          <input 
            type='text' 
            id='categoryName' 
            name='categoryName'
            value={data.categoryName} 
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded' required
          />

          <label htmlFor='uploadImageInput'>Category Image:</label>
          <label htmlFor='uploadImageInput' className='cursor-pointer'>
            <div className='p-2 bg-slate-100 border rounded h-32 flex justify-center items-center'>
              {data.image ? (
                <div className='relative group'>
                  <img src={data.image} alt='Category' className='h-32' />
                  <div className='absolute top-0 right-0 p-1 text-white bg-red-600 rounded-full cursor-pointer' onClick={handleDeleteImage}>
                    <MdDelete />
                  </div>
                </div>
              ) : (
                <div className='text-slate-500 flex flex-col items-center gap-2'>
                  <FaCloudUploadAlt className='text-4xl' />
                  <p className='text-sm'>Upload Category Image</p>
                  <input type='file' id='uploadImageInput' className='hidden' onChange={handleUploadImage} />
                </div>
              )}
            </div>
          </label>

          <label>Subcategories:</label>
          {data.subCategories.map((subCategory, index) => (
            <div key={index} className='flex items-center gap-2'>
              <input 
                type='text' 
                value={subCategory} 
                onChange={(e) => handleSubCategoryChange(index, e.target.value)}
                className='p-2 bg-slate-100 border rounded flex-1'
                placeholder='Subcategory name'
              />
              <button 
                type='button' 
                className='text-red-600 hover:text-red-800' 
                onClick={() => handleRemoveSubCategory(index)}
              >
                <MdDelete />
              </button>
            </div>
          ))}
          <button 
            type='button' 
            className='px-3 py-1 bg-green-600 text-white hover:bg-green-700 rounded'
            onClick={handleAddSubCategory}
          >
            Add Subcategory
          </button>

          <button className='px-3 py-2 bg-red-600 text-white hover:bg-red-700'>Update Category</button>
        </form>
      </div>
    </div>
  );
};

export default AdminEditCategory;
